import React from 'react';
import { Grid } from 'semantic-ui-react';
import FileUploadButton from '../../fileUploadButton';

const Images = ({ obj, onChange }) => {
  const presentationVideo = obj.section_presentation_video
    ? obj.section_presentation_video
    : null;
  const presentationBg = obj.section_presentation_bg
    ? obj.section_presentation_bg
    : null;
  const categoryBgLayer1 = obj.section_category_bg_layer1
    ? obj.section_category_bg_layer1
    : null;
  const categoryBgLayer2 = obj.section_category_bg_layer2
    ? obj.section_category_bg_layer2
    : null;
  const infoBg = obj.section_info_bg ? obj.section_info_bg : null;

  return (
    <div>
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="section_presentation_video"
              label="Bloc présentation (vidéo)"
              image={presentationVideo}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="section_presentation_bg"
              label="Bloc présentation (image)"
              image={presentationBg}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="section_category_bg_layer1"
              label="Bloc catégorie (image 1)"
              image={categoryBgLayer1}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="section_category_bg_layer2"
              label="Bloc catégorie (image 2)"
              image={categoryBgLayer2}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="section_info_bg"
              label="Bloc info"
              image={infoBg}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default Images;



// WEBPACK FOOTER //
// ./src/components/form/homepage/images.js